import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import Component from "./View";

const mapStateToProps = (state: RootState, props: any) => ({
  countryCode: selectors.getAccountCountryCode(state),
  extraInfo: selectors.getExtraInfo(state, props.modalId)
});

const mapDispatchToProps = {};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
